export default "/assets/e0049eabc12e83008f5072b4bd866b22.woff";